import { VenetianMaskIcon } from "lucide-react";
import { Card } from "@component/card";
import type { TrainingPersona } from "@type/training";
import { cn } from "@util/tailwind";

interface Props {
    personas: TrainingPersona[];
    selectedId: string | null;
    onSelect: (id: string) => void;
}

export function TrainingPersonaPicker({ personas, selectedId, onSelect }: Props) {
    return (
        <div className="flex flex-col gap-3">
            {personas.map((p) => {
                const active = selectedId === p.id;
                return (
                    <Card
                        key={p.id}
                        className={cn(
                            "transition-all cursor-pointer overflow-hidden",
                            active
                                ? "border-blue-600 ring-2 ring-blue-200 bg-blue-50/30"
                                : "border-gray-200 hover:border-gray-300 bg-white"
                        )}
                        onClick={() => onSelect(p.id)}
                    >
                        <div className="flex gap-4 p-4">
                            <div className="flex-shrink-0 mt-0.5">
                                <div
                                    className={cn(
                                        "w-5 h-5 rounded-full border-2 flex items-center justify-center",
                                        active
                                            ? "border-blue-600 bg-blue-600"
                                            : "border-gray-300"
                                    )}
                                >
                                    {active && (
                                        <div className="w-2 h-2 rounded-full bg-white" />
                                    )}
                                </div>
                            </div>
                            <div className="flex-shrink-0">
                                <div
                                    className={cn(
                                        "w-10 h-10 flex items-center justify-center rounded-lg",
                                        active ? "bg-blue-100" : "bg-blue-50"
                                    )}
                                >
                                    <VenetianMaskIcon className="w-5 h-5 text-blue-600" />
                                </div>
                            </div>
                            <div className="flex-1 min-w-0">
                                <div
                                    className={cn(
                                        "font-semibold text-sm mb-1",
                                        active ? "text-blue-900" : "text-gray-900"
                                    )}
                                >
                                    {p.name}
                                </div>
                                <div className="text-sm text-gray-600 mb-3">
                                    {p.description}
                                </div>
                                <div className="border-t border-gray-100 pt-2.5">
                                    <div className="text-[10px] uppercase tracking-wide text-gray-400 mb-1">
                                        Employee briefing
                                    </div>
                                    <div className="text-xs text-gray-500 leading-relaxed">
                                        {p.briefing}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                );
            })}
        </div>
    );
}
